// extracted by mini-css-extract-plugin
export default {"container":"PagePopup__container--1_Y","isWhiteBg":"PagePopup__isWhiteBg--350"};